import { FavoritesControllerApi } from 'generated/api/apis/FavoritesControllerApi'
import { UserControllerApi } from 'generated/api/apis/UserControllerApi'
import { createConfiguration, createFionaClient } from 'services/FionaAPI/templates/ClientFactory'

const UserClientFactory = () => {
	const client = new UserControllerApi(createConfiguration())
	const unauthenticatedClient = new UserControllerApi()
	return {
		getUser: createFionaClient(client.userControllerGetUserById.bind(client)),
		upgradeUser: createFionaClient(client.userControllerUpgrade.bind(client)),
		createAnonymous: createFionaClient(
			unauthenticatedClient.userControllerGetAnonymousUser.bind(unauthenticatedClient)
		),
		disableUser: createFionaClient(client.userControllerDisable.bind(client)),
		addConsents: createFionaClient(client.userControllerAddUserConsents.bind(client)),
		editUser: createFionaClient(client.userControllerEditUser.bind(client))
	}
}
type UserClient = ReturnType<typeof UserClientFactory>
let userClientInstance: UserClient
export const getUserClient = (rebuild = false) => {
	if (rebuild || !userClientInstance) {
		userClientInstance = UserClientFactory()
	}
	return userClientInstance
}

const FavoriteClientFactory = () => {
	const client = new FavoritesControllerApi(createConfiguration())
	return {
		addFavorite: createFionaClient(client.favoritesControllerAddFavorite.bind(client)),
		removeFavorite: createFionaClient(client.favoritesControllerRemoveFavorite.bind(client)),
		getAllFavorites: createFionaClient(client.favoritesControllerGetAllFavorites.bind(client)),
		getFavoriteById: createFionaClient(client.favoritesControllerGetFavoriteById.bind(client))
	}
}
type FavoriteClient = ReturnType<typeof FavoriteClientFactory>
let favoriteClientInstance: FavoriteClient
export const getFavoriteClient = (rebuild = false) => {
	if (rebuild || !favoriteClientInstance) {
		favoriteClientInstance = FavoriteClientFactory()
	}
	return favoriteClientInstance
}
